module.exports = __webpack_public_path__ + "static/media/contact-us-header.c2ea7412.png";